import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { supabase } from '@/lib/supabase'
import { Loader2 } from 'lucide-react'

export default function AuthCallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_IN' && session?.user) {
          const user = session.user
          const avatarUrl = user.user_metadata?.avatar_url as string | undefined
          if (avatarUrl) {
            const { data: profile, error: fetchErr } = await supabase
              .from('profiles')
              .select('avatar_url')
              .eq('id', user.id)
              .single()

            if (fetchErr) {
              console.error('プロフィール取得に失敗:', fetchErr.message)
            } else if (profile && !profile.avatar_url) {
              const { error: updateErr } = await supabase
                .from('profiles')
                .update({ avatar_url: avatarUrl })
                .eq('id', user.id)
              if (updateErr) {
                console.error('アバター更新に失敗:', updateErr.message)
              }
            }
          }
          navigate('/', { replace: true })
        }
      },
    )

    // Fallback: if no auth event fires within 10s, redirect to login
    const timeout = setTimeout(() => {
      navigate('/login?error=auth', { replace: true })
    }, 10000)

    return () => {
      subscription.unsubscribe()
      clearTimeout(timeout)
    }
  }, [navigate])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="size-8 animate-spin text-muted-foreground" />
    </div>
  )
}
